import {theme} from "react-treebeard";

const codeTreeTyle = $.extend(true, theme, {
    base: {
        backgroundColor: '#F2F2F2',
        color: '#222'
    },
    tree: {
        base: {
            backgroundColor: '#F2F2F2',
            color: '#222'
        },
        node: {
            toggle: {

            },
            activeLink: {
                background: '#D6D6D6'
            }
        }
    }
});

export default codeTreeTyle;



// WEBPACK FOOTER //
// ./Client/Views/TreeStyle.ts